<template>
  <modal type="text/x-template" id="modalLogin">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header">
              <div class="header">
                <h4 class="title">Login</h4>
              </div>
              <div class="close-modal">
                <button class="button-close" @click="$emit('close')">X</button>
              </div>
            </div>

            <div v-if="getCurrentUser != null" class="modal-body">
              <p>
                El usuario {{ getCurrentUser.email }} esta logeado. Desea
                desconectarse?
              </p>
              <div class="container-button">
                <b-button
                  class="modal-default-button"
                  type="submit"
                  variant="primary"
                  @click.prevent="disconect()"
                  >Desconectar</b-button
                >
              </div>
            </div>
            <div v-else class="modal-body">
              <b-form-group id="newsletter">
                <b-form-input
                  id="newsletter"
                  v-model="user"
                  type="email"
                  placeholder="Usuario"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <b-form-input
                  v-model="password"
                  type="password"
                  placeholder="Contraseña"
                ></b-form-input>
              </b-form-group>
              <div class="container-button">
                <b-button
                  class="modal-default-button"
                  type="submit"
                  variant="primary"
                  @click.prevent="login()"
                  >Ingresar</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </modal>
</template>

<script>
import firebase from "firebase/firebase";
import "firebase/auth";

export default {
  data() {
    return {
      user: "",
      password: "",
    };
  },
  mounted() {},
  computed: {
    getCurrentUser() {
      return firebase.auth().currentUser;
    },
  },
  methods: {
    login() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.user, this.password)
        .then(
          (user) => this.$store.commit("SET_AUTH", user),
          (error) => alert("Error al logear", error)
        );
      this.$emit("close");
    },
    disconect() {
      firebase
        .auth()
        .signOut()
        .then(
          (user) => this.$store.commit("SET_AUTH", null),
          (error) => alert("Error al deslogear", error)
        );
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.header {
  width: 90%;
  margin-left: 10%;
  padding: 10px;
}

.modal-footer {
  display: inherit;
}

.produts-title {
  text-align: center;
  font-weight: bold;
}
.title {
  font-weight: 800;
}
.close-modal {
  width: 10%;
  text-align: end;
}
.button-close {
  background: red;
  border-radius: 20px;
  padding: 10px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 50%;
  margin: 0px auto;
  padding: 0px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  min-width: fit-content;
  overflow-y: auto;
  border-radius: 10px !important;
}

.modal-header {
  margin-top: 0;
  color: #212529;
  text-align: center;
  justify-content: center;
  align-self: center;
}

.modal-body {
  margin: 5px 0;
  padding: 5%;
}

.container-button {
  padding: 15px;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>


// WEBPACK FOOTER //
// src/components/ModalLogin.vue